<template>
  <header class="header fixed" :class="{'bgcF':headerColor}" ref="header">
    <div class="container between">
      <div class="header__left">
        <div class="logo">
          <nuxt-link to="/">
            <img src="~/img/logo_new.png" alt="" class="header-logo">
          </nuxt-link>
        </div>
      </div>
      <div class="items-center">
        <header-nav />
      </div>
      <div class="header__right items-center">
        <header-tool />
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>

  let headerColor: any = ref(false)
  const handleScroll = () => {
    const scrollY = window.scrollY
    headerColor.value = (scrollY >= 70) ? true : false
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });
</script>

<style scoped lang="scss">
  .header{
    width: 100%;
    height: 70px;
    top: 0;
    z-index: 99;
    background: transparent;
    // min-width: 1500px;
    &.bgcF{
      background: #fff;
    }
    .container{
      margin: 0 80px 0 70px;
      padding-top: 19px;
      font-size: 17px;
      .logo img{
        height: 38px;
      }
    }
    &__left {
      display: flex;
    }
  }

</style>